import React, { useState } from 'react';
import { recipeScheduleAPI } from '../../utils/api';
import DaySelector from './DaySelector';
import CustomDatePicker from './CustomDatePicker';
import MealTypeSelector from './MealTypeSelector';
import useSwipeToClose from '../../hooks/useSwipeToClose';
import './RecipeScheduleModal.css';

const RecipeScheduleModal = ({ isOpen, onClose, recipe, onScheduleSuccess }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [showCustomDatePicker, setShowCustomDatePicker] = useState(false);
  const [showMealTypeSelector, setShowMealTypeSelector] = useState(false);
  const [selectedDate, setSelectedDate] = useState('');

  // Add swipe to close functionality
  const swipeRef = useSwipeToClose(onClose, isOpen);

  const handleDaySelect = (selectedDate) => {
    // Instead of immediately scheduling, show meal type selector
    setSelectedDate(selectedDate);
    setShowMealTypeSelector(true);
  };

  const handleMealTypeSelect = async (date, mealType) => {
    try {
      setLoading(true);
      setError('');

      await recipeScheduleAPI.scheduleRecipe(recipe.id, date, mealType);
      
      if (onScheduleSuccess) {
        onScheduleSuccess();
      }
      
      onClose();
    } catch (err) {
      console.error('Scheduling error:', err);
      setError(err.message || 'Failed to schedule recipe');
    } finally {
      setLoading(false);
    }
  };

  const handleMealTypeSelectorBack = () => {
    setShowMealTypeSelector(false);
    setSelectedDate('');
  };

  const handleCustomDateSelect = () => {
    setShowCustomDatePicker(true);
  };

  const handleCustomDateConfirm = (selectedDate) => {
    // For custom dates, also show meal type selector
    setSelectedDate(selectedDate);
    setShowCustomDatePicker(false);
    setShowMealTypeSelector(true);
  };

  const handleCustomDateCancel = () => {
    setShowCustomDatePicker(false);
  };

  const handleModalClose = () => {
    setShowCustomDatePicker(false);
    setShowMealTypeSelector(false);
    setSelectedDate('');
    setError('');
    onClose();
  };

  if (!isOpen || !recipe) return null;

  return (
    <div className="schedule-modal-overlay" onClick={handleModalClose}>
      <div className="schedule-modal-content" onClick={e => e.stopPropagation()} ref={swipeRef}>
        <div className="schedule-modal-header">
          <h2>Schedule Recipe</h2>
          <button className="schedule-close-button" onClick={handleModalClose}>×</button>
        </div>

        <div className="schedule-modal-body">
          <div className="recipe-info">
            <h3>{recipe.title}</h3>
            {recipe.image_url && (
              <img src={recipe.image_url} alt={recipe.title} className="recipe-thumbnail" />
            )}
          </div>

          {error && <div className="schedule-error-message">{error}</div>}

          {showMealTypeSelector ? (
            <MealTypeSelector
              selectedDate={selectedDate}
              onMealTypeSelect={handleMealTypeSelect}
              onBack={handleMealTypeSelectorBack}
              loading={loading}
            />
          ) : showCustomDatePicker ? (
            <CustomDatePicker
              onDateSelect={handleCustomDateConfirm}
              onCancel={handleCustomDateCancel}
              loading={loading}
            />
          ) : (
            <DaySelector
              onDaySelect={handleDaySelect}
              onCustomDateSelect={handleCustomDateSelect}
              loading={loading}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default RecipeScheduleModal;